import Vue from 'vue'
import VueRouter from 'vue-router'
import { BASE_ROUTE_URL } from '@/constants/config'
import errorRoutes from './routes/error-routes'
import authRoutes from './routes/auth-routes'
import superadminRoutes from '@/router/routes/superadmin-routes'
import adminRoutes from '@/router/routes/admin-routes/index.ts'
import paymentRoutes from '@/router/routes/payment-routes'
import homeRedirect from '@/router/utils/home-redirect'
import multiGuard from '@/router/utils/vue-router-multiguard'
import checkUserTypeGuard from '@/router/guards/check-user-type-guard'
import billingRoutes from '@/router/routes/billing-routes'
import updateNavigationStoreGuard from '@/router/guards/update-navigation-store-guard'
import checkAdminPermissionsGuard from '@/router/guards/check-admin-permissions-guard'
import checkImpersonateGuard from '@/router/guards/check-impersonate-guard'
import checkRouteLocaleGuard from '@/router/guards/check-route-locale-guard'
import AppendUtmGuard from '@/router/guards/append-utm-guard'
import chunkFailedHandler from '@/router/utils/chunk-failed-handler'
import shortcutGuard from '@/router/guards/shortcut-guard'

// To avoid throwing errors when updating the route query (like inject utm) or duplicate same route (for unknown reason ¯\_(ツ)_/¯)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err
    }
    // rethrow error
    return Promise.reject(err)
  })
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: BASE_ROUTE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: homeRedirect,
    },
    ...authRoutes,
    ...superadminRoutes,
    ...adminRoutes,
    ...billingRoutes,
    ...paymentRoutes,
    ...errorRoutes,
  ],
})

router.beforeEach((...params) => multiGuard([checkRouteLocaleGuard, checkImpersonateGuard, checkUserTypeGuard, checkAdminPermissionsGuard, updateNavigationStoreGuard, AppendUtmGuard, shortcutGuard])(...params))

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.onError(chunkFailedHandler)

export default router
